import { useIsMutating, useQuery } from '@tanstack/react-query';

import { sessionByIdOptions, mutationKeys as sessionMutationKeys } from '@/entities/session';
import { mutationKeys } from '@/entities/session-note';

export const useIsGenerating = (sessionId: string) => {
    const { data: session } = useQuery(sessionByIdOptions(sessionId));
    const note = session?.currentNote;

    const generatingCount = useIsMutating({
        mutationKey: mutationKeys.generate(sessionId),
    });
    const updatingSessionCount = useIsMutating({
        mutationKey: sessionMutationKeys.updateSession(sessionId),
    });

    return (
        generatingCount > 0 ||
        updatingSessionCount > 0 ||
        (note?.generator != null && note.generator.status !== 'DONE')
    );
};
